import { AppSettings, AppSettingsService, Context, createObservableValue, throwNotImplemented } from '@prodcard/core'

class DumbAppSettingsService implements AppSettingsService {
  devMode = createObservableValue<boolean, Context>(false)
  load(): Promise<AppSettings> {
    throwNotImplemented('<8fd17f5d>')
  }
  save(): Promise<void> {
    throwNotImplemented('<41923686>')
  }
}

export const appSettingsService = new DumbAppSettingsService()
